export const visualPayload = (response) => {
  const { table = [], lookups: { g1 = {}, g1_l2 = [] } = {} } =
    response?.data || {};
  return table?.map((curr) => {
    const group = curr[2];
    const value = curr[4];

    if (Array.isArray(g1[group])) {
      const nameLookup = g1?.[group]?.map((g1) => g1_l2[g1]?.name);
      const idLookup = g1?.[group]?.map((g1) => g1_l2[g1]?.id);

      return {
        value,
        name: nameLookup?.join(','),
        id: idLookup?.join(','),
      };
    }

    if (typeof g1[group] === 'object') {
      return { value, ...g1[group] };
    }
    return { value, key: g1[group] };
  }, []);
};
